var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.154 0.846C10.6868 0.378767 9.92923 0.378767 9.462 0.846L6 4.308L2.538 0.845999C2.07077 0.378767 1.31323 0.378767 0.846 0.846V0.846C0.378767 1.31323 0.378767 2.07077 0.846 2.538L4.308 6L0.845999 9.462C0.378767 9.92923 0.378767 10.6868 0.846 11.154V11.154C1.31323 11.6212 2.07077 11.6212 2.538 11.154L6 7.692L9.462 11.154C9.92923 11.6212 10.6868 11.6212 11.154 11.154V11.154C11.6212 10.6868 11.6212 9.92923 11.154 9.462L7.692 6L11.154 2.538C11.6212 2.07077 11.6212 1.31323 11.154 0.846V0.846Z",
    fill: "#262F3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSmall);
export default __webpack_public_path__ + "static/media/close_small.cc1cb3009aacc770d9045d91ee1d76bc.svg";
export { ForwardRef as ReactComponent };